module.exports = __webpack_public_path__ + "static/media/careerorentation2.809e3505.jpg";